// What the chore form's schedule presets count from, remembered on this device so the next chore
// is made the way the last one was. From when it's done unless "A fixed day" was picked last.
// The same as domain's ScheduleAnchor, which lib can't import.
type ScheduleAnchor = 'done' | 'fixed';

const KEY = 'choreschamp.scheduleAnchor';

export function loadScheduleAnchor(): ScheduleAnchor {
  try {
    return localStorage.getItem(KEY) === 'fixed' ? 'fixed' : 'done';
  } catch {
    return 'done';
  }
}

export function saveScheduleAnchor(anchor: ScheduleAnchor): void {
  try {
    localStorage.setItem(KEY, anchor);
  } catch {
    // Not remembered, then: the presets count from when it's done next time.
  }
}
